<template>
    <div class="clearfix">
        <div v-if="items.length === 0 && !noResults">
            Loading...
        </div>
        <div v-if="noResults">
            <br />
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                There are no trending stocks to show
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div v-else>
            <table class="table table-dark table-sm table-striped table-hover table-bordered small">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Code</th>
                        <th scope="col">AvgSpend</th>
                        <th scope="col">WinRatio</th>
                        <th scope="col">Total</th>
                        <th scope="col"></th>
                        
                    </tr>
                </thead>
                <tbody>
                   
                    <tr v-for="i in items" :key="i.key" class='@(item.Row > 10 ? "opaque" : "")'>
                        <td> {{ i.row }}</td>                  
                        <td class="text-center"><a class="text-white" :href="'/Trades/Individual?security=' + i.code + '&marketId=' + i.marketId">{{ i.code }}</a></td>
                        <td class="text-right">{{ i.avgSpend | currency('$') }}</td>
                        <td class="text-right">{{ i.winRatio | numberFormatSingle  }}</td>
                        <td class="text-right">{{ i.total }}</td>
                        <td>
                            <span class="badge badge-pill badge-secondary">{{ i.closeMin45Day | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-secondary">{{ i.closeMin30Day | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-secondary">{{ i.closeMin15Day | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-primary">{{ i.closeOnDay | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-light">{{ i.close15Day | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-light">{{ i.close30Day | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-light">{{ i.close45Day | numberFormatSingle }}</span>
                            <span class="badge badge-pill badge-light">{{ i.close60Day | numberFormatSingle }}</span>
                        </td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
    import axios from 'axios';    

    export default {
        props: {
            
        },
        data: function () {
            return {                
                items: [],                                  
                noResults: false
            }
        },
        async mounted() {
            this.getTrendingStocks();            
        },
        methods: {            
            getData(obj) {
                console.log(obj);                
            },            
            async getTrendingStocks() {

                const { data } = await axios.get('/analysis/TrendingStocks', {
                    params: {
                                           
                    }
                });

                this.items = data;
                this.noResults = data.length === 0;
            }
        }
    }
</script>